import { Box } from "@mui/system"
import { useState, useEffect } from "react"


export default function CSVconLLU({searchResult}) {

    const [table, setTable] = useState([])


    useEffect(()=> {

      let  data = []

        for (const item of searchResult) {
            let translation = item[5]
            for (let index = 0; index < item[2].length; index++) {
                let obj = {}

                obj['UD_id'] = index + 1;
                obj['token'] = item[2][index];
                obj['lemma'] = item[3][index];
                obj['PoS_tag'] = item[4][index];
                obj['PoS_tag_ext'] = item[8][index];
                obj['_'] = '_';
                obj['ID_of_parent'] =item[9][index];

                obj['UD'] = obj['UD'] = item[6][index];
                obj['dependency'] = `${item[9][index]}:${item[6][index]}`
                obj['translation'] = '_';
                data.push(obj)
                }
            data.push({'UD_id': `# ${translation}`, 'token': '', 'lemma': '', 'PoS_tag': '', 'PoS_tag_ext': '', '_': '', 'ID_of_parent': '', 'UD': "", 'dependency': '', 'translation': '' })
            data.push({'UD_id': '', 'token': '', 'lemma': '', 'PoS_tag': '', 'PoS_tag_ext': '', '_': '', 'ID_of_parent': '', 'UD': "", 'dependency': '', 'translation': '' })
        }

        setTable(data)



    }, [searchResult]);





            let text = '';
        for (let item of table) {

            for (const [, value] of Object.entries(item)) {
                text += value;
                text += "\t"
            }
            text += "\n"
        }


        const file = new Blob([text], {type: "text/plain; charset=utf-8"});

    return(

        <>
        {(searchResult.length >= 1) ?
                <Box mt={2}><a href={URL.createObjectURL(file)}   download = "conllu.txt">Download CoNLL-U</a> </Box>  : null  }

        </>

    )



}//  <CSVLink  {...csvFile}   separator={separator}> Download CoNLL-U </CSVLink>

//